module.exports = __webpack_public_path__ + "img/b5.264bceb7.webp";